// import BigLogo from "../images/logo-enhanced.svg";
import BigLogo2 from "../images/logo-quantum-energy-01.svg";
import Video from "../components/Video";
import Bg1 from "../videos/bg-abstract-quantum-01-1080p.mp4";
import { Link } from "react-router-dom";
// import Granim from "granim";

const Hero = () => {
  return (
    <section className="banner banner--style2" id="home">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 col-lg-6 offset-0 offset-lg-3 text-center">
            <p>
              <img
                className="logo-banner"
                alt="Quantum Energy"
                src={BigLogo2}
              />
            </p>

            <div
              className="banner__content text-center"
              data-aos="zoom-in"
              data-aos-delay="1000"
              data-aos-duration="100"
            >
              <h4>
                A Deterministic Perpetual Airdrop Engine Utilizing Internalized
                Game Theory
              </h4>
              <h5>Energize your Portfolio</h5>
              <p>
                <Link to="/dashboard">
                  <span
                    className="default-btn py-1 "
                    href="#"
                    data-bs-toggle="modal"
                    data-bs-target="#wallet-option"
                  >
                    <i className="fs-3 bi bi-speedometer2"></i>{" "}
                    <span>Dashboard</span>
                  </span>
                </Link>
              </p>
            </div>
            <div id="videoBG"></div>
            <canvas id="canvas-home" className="text-center wave-bg"></canvas>
            <Video vidSrc={Bg1} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
